var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessToast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.50033,
    y: 5.49984,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "#079455",
    strokeWidth: 1.66667
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.33333,
    y: 1.33333,
    width: 33.3333,
    height: 33.3333,
    rx: 16.6667,
    stroke: "#079455",
    strokeWidth: 1.66667
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3469_1009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2503 17.9998L16.7503 20.4998L21.7503 15.4998M26.3337 17.9998C26.3337 22.6022 22.6027 26.3332 18.0003 26.3332C13.398 26.3332 9.66699 22.6022 9.66699 17.9998C9.66699 13.3975 13.398 9.6665 18.0003 9.6665C22.6027 9.6665 26.3337 13.3975 26.3337 17.9998Z",
    stroke: "#079455",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3469_1009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToast);
export default __webpack_public_path__ + "static/media/successToast.bab58b53f3d48b4d6214b57974840187.svg";
export { ForwardRef as ReactComponent };